import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
import { ReadWebMerchantAppOrderTypeMenuCardDto } from './ReadWebMerchantAppOrderTypeMenuCardDto';
export class ReadWebMerchantAppOrderTypeScreenDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "options", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    ValidateNested({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", Object)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "navigationBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    ValidateNested({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", Object)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "container", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    ValidateNested({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "cardTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "textOnImage", void 0);
__decorate([
    ApiProperty({ type: () => ReadWebMerchantAppOrderTypeMenuCardDto, isArray: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    Type(() => ReadWebMerchantAppOrderTypeMenuCardDto),
    __metadata("design:type", Array)
], ReadWebMerchantAppOrderTypeScreenDto.prototype, "cardList", void 0);
//# sourceMappingURL=ReadWebMerchantAppOrderTypeScreenDto.js.map